import each from 'lodash/each'
import isObject from 'lodash/isObject'

import eventHash from 'base/events.yml'

const namespace = function (node, keyPrefix = '') {
  if (!node || !Object.values(node).every(value => value === null || isObject(value))) {
    return Object.assign(
      {
        name: keyPrefix.slice(0, -1),
        autoTrack: true,
      },
      node || {},
    )
  } else {
    const ret = {}
    each(node, (value, key) => (ret[key] = namespace(value, `${keyPrefix}${key}.`)))
    return ret
  }
}

export default namespace(eventHash)
